import { getDate, getTimeStamp } from "@common/util/getDate";

/**
 * 사용자 라우팅 정보를 추적하는 훅
 * @returns {object} 라우팅 추적 관련 함수
 */
const useRouteTracker = () => {
  const checkRouter = (url) => {
    if (url.includes("[slug]")) return;

    // 제품 코드 추적
    const pcodeMatch = url.match(/P(\d{16})/); // P+16자리 숫자 찾기
    if (pcodeMatch) {
      const pcode = pcodeMatch[0];
      const today = getDate();
      const products = JSON.parse(sessionStorage?.getItem(today) || "[]");

      if (products.includes(pcode)) {
        return;
      }

      products.push(pcode);
      sessionStorage?.setItem(today, JSON.stringify(products));
    }

    // 방문 경로 추적
    const date = getTimeStamp();
    const routes = JSON.parse(sessionStorage?.getItem("route") || "[]");
    const routesDate = [];

    routes.forEach((el) => {
      for (const key in el) {
        if (key.slice(0, 11) === String(date).slice(0, 11))
          routesDate?.push(el);
      }
    });

    if (routesDate?.length) return;

    routes.push({ [date]: url });
    sessionStorage?.setItem("route", JSON.stringify(routes));
  };

  return { checkRouter };
};

export default useRouteTracker;
